// 日本語の文章

import type { ContentText } from "./types";

export const ja: ContentText = {
  locale: "ja",

  types: {
    "king": {
      "label": "王",
      "front": "みんなの前に立ち、決めて、背負う",
      "back": "自分の人生の舵を、誰にも渡さずに握っている"
    },
    "lover": {
      "label": "恋人",
      "front": "人の気持ちに寄り添い、まわりをあたためる",
      "back": "たったひとりを想って、胸を焦がしている"
    },
    "fool": {
      "label": "道化",
      "front": "笑いで空気をほぐし、場を明るくする",
      "back": "どうでもいい空想で、自分をくすくす笑わせている"
    },
    "schemer": {
      "label": "策士",
      "front": "全体を見渡し、静かに先を読む",
      "back": "これからの作戦を、ひそかに練っている"
    },
    "warrior": {
      "label": "戦士",
      "front": "迷わず前に出て、困難に挑む",
      "back": "まだ誰も成し遂げていないことに、闘志を燃やしている"
    },
    "dreamer": {
      "label": "夢見る人",
      "front": "目の前の現実の向こうに、理想を思い描く",
      "back": "まだ見ぬ未来を思い描いて、怖くなったり、燃えたりする"
    }
  },

  questions: [
    { text: "会議で、意見が真っ二つに割れた。", choices: ["「ここは私が決めます」と結論を出す", "「一回、笑いましょう」と空気をほぐす", "黙って全体を見渡し、落としどころを考える"] },
    { text: "新しいチームに入った初日。", choices: ["自分から全員に話しかけ、輪の中心に立つ", "ユーモアで距離を縮めつつ、人間関係を観察する", "隅で様子を見ながら、自分にしかできないことを探す"] },
    { text: "締め切りが、どう考えても間に合わない。", choices: ["「なんとかなる！」と笑って、みんなを乗せる", "頼んだ人の気持ちを考え、正直に相談する", "段取りを組み直し、徹夜でも突っ走る"] },
    { text: "誰かが人前で、明らかに間違ったことを言った。", choices: ["場を収めるために、うまく話題を切り替える", "言われた人をかばって、すぐ言い返す", "心の中でツッコみつつ、黙って様子を見る"] },
    { text: "人から褒められた。", choices: ["素直に受け取り、もっと大きな夢を語る", "褒めてくれた人を、すかさず褒め返す", "照れて笑いにしつつ、次はもっとやってやると燃える"] },
    { text: "大事な発表の前の夜。", choices: ["「主役は私だ」と言い聞かせ、堂々と眠る", "聞く人の顔を思い浮かべ、話し方を工夫する", "想定質問を書き出し、頭の中で何度もリハーサル"] },
    { text: "誰にも予定を聞かれない、まるごと自由な一日。", choices: ["仲間を集め、自分の企画で一日を仕切る", "ひとりで本や映画に浸り、人間観察のネタを集める", "行きたかった場所へ、思いつきで飛び出す"] },
    { text: "本当は誰にも言っていない夢。", choices: ["みんなを笑顔にする、真ん中の人でいたい", "たった一人と、深く分かり合いたい", "誰も成し遂げていないことを、やり遂げたい"] },
    { text: "眠れない夜に考えてしまうこと。", choices: ["これからの人生の作戦", "言えなかった気持ちを、明日こそ伝えようと決める", "どうでもいい空想が止まらない"] },
    { text: "大切なものを失ったとき。", choices: ["その意味を考え、生き方を決め直す", "失ったものへの想いを、形を変えて取り戻そうとする", "泣いて、笑って、とにかく体を動かす"] },
    { text: "森で道に迷った。", choices: ["高いところに登って、進む道を決める", "出会った誰かと、話しながら歩く", "迷ったことさえ楽しみ、地図を描きながら進む"] },
    { text: "幕が下りる、最後の場面。あなたはどうありたい？", choices: ["愛する人たちに囲まれて、真ん中で幕を迎えたい", "最後に一言、客席を笑わせて去りたい", "静かに袖へ。でも、何かを成し遂げた顔で"] },
  ],

  roles: {
    henry5: {
      name: "ヘンリー五世",
      play: "ヘンリー五世",
      word: "揺るがなさ",
      intro: "若き日の放蕩を捨て、イングランドを率いて戦場に立った王。兵士と同じ目線で語りかけ、人の心をひとつにする。",
      quote: "もう一度あの突破口へ、友よ、もう一度！",
      costarReason: "若き日の悪友。王になったあなたに、肩書きを脱いで笑う自由を思い出させてくれる人。",
    },
    cleopatra: {
      name: "クレオパトラ",
      play: "アントニーとクレオパトラ",
      word: "揺らめき",
      intro: "エジプトの女王。国を背負う誇りと、ローマの将軍アントニーへの激しい恋を、どちらも最後まで手放さなかった。",
      quote: "私の中に、永遠への憧れがある。",
      costarReason: "あなたの気まぐれな演出に、皮肉とユーモアで応えてくれる、退屈しない人。",
    },
    lear: {
      name: "リア王",
      play: "リア王",
      word: "振れ幅",
      intro: "娘たちに王国を分け与え、嵐の荒野をさまよう中で、本当の愛と本当の自分に気づいていく老王。",
      quote: "わしが誰なのか、教えてくれる者はおらんか？",
      costarReason: "どんな嵐のあとでも、歌であなたの心を癒やしてくれる人。本当の愛のかたちを教えてくれる。",
    },
    margaret: {
      name: "マーガレット",
      play: "ヘンリー六世 第3部",
      word: "凄み",
      intro: "気弱な王に代わって軍を率いた王妃。誰よりも強く、誰よりも先を読み、薔薇戦争を戦い抜いた。",
      quote: "賢い者は、失ったものを嘆いて座りこんだりしない。どう取り戻すかを、明るく探すのだ。",
      costarReason: "一歩も引かずに渡り合える好敵手。張り合うほど、あなたの凄みが磨かれる。",
    },
    katherine: {
      name: "キャサリン王妃",
      play: "ヘンリー八世",
      word: "気高さ",
      intro: "王に離縁を迫られても、法廷で一歩も引かずに自らの正しさを訴え続けた王妃。",
      quote: "陛下、どうか私に、正しい裁きを。",
      costarReason: "あなたの気高さを理解し、ともに一歩も引かずに立ってくれる人。",
    },
    richard2: {
      name: "リチャード二世",
      play: "リチャード二世",
      word: "詩情",
      intro: "王であることを誰よりも美しく語った王。王冠を失ったとき、はじめてひとりの人間として自分を見つめる。",
      quote: "頼む、地面に座ろう。そして王たちの死の、悲しい物語を語ろう。",
      costarReason: "あなたの詩に耳を傾け、同じように揺れながら寄り添ってくれる人。",
    },
    hermione: {
      name: "ハーマイオニ",
      play: "冬物語",
      word: "芯の強さ",
      intro: "嫉妬に狂った王に疑われながらも、品位を失わずに真実を訴えた王妃。16年の時を経て、奇跡のように再び姿を現す。",
      quote: "私は、世の多くの女性のようには泣きません。",
      costarReason: "あなたの静かな強さに救われて、少しずつ心をほどいていく人。",
    },
    juliet: {
      name: "ジュリエット",
      play: "ロミオとジュリエット",
      word: "一途さ",
      intro: "仮面舞踏会でひと目で恋に落ち、家と家の憎しみを越えて、愛を選んだ13歳の少女。",
      quote: "名前が何だというの？ バラと呼ぶあの花は、ほかの名前で呼んでも、甘く香るわ。",
      costarReason: "同じように一途に人を想う人。あなたの恋を、誰よりも真剣に応援してくれる。",
    },
    launce: {
      name: "ラーンス",
      play: "ヴェローナの二紳士",
      word: "愛嬌",
      intro: "主人に仕える従者。つれない愛犬クラブへの片想いのような愛情を、ひとり芝居で笑いに変えてしまう。",
      quote: "うちの犬のクラブときたら、世界一つれない犬だと思いますよ。",
      costarReason: "あなたのひとり芝居に、全力で乗っかってくれる相方。",
    },
    helena: {
      name: "ヘレナ",
      play: "終わりよければすべてよし",
      word: "しなやかさ",
      intro: "身分違いの恋をあきらめず、知恵と行動で道を切り開いた医者の娘。",
      quote: "救いはたいてい、自分の中にある。私たちはそれを、天のおかげと呼んでいるだけ。",
      costarReason: "身分の壁なんて気にしない、型破りな味方。あなたの挑戦を大声で応援してくれる。",
    },
    imogen: {
      name: "イモジェン",
      play: "シンベリン",
      word: "ひたむきさ",
      intro: "夫を信じ抜き、男装して険しい山を越えた王女。どんな試練の中でも、愛を手放さなかった。",
      quote: "見えるのは目の前の道だけ。こちらも、あちらも、その先も、霧がかかって見通せない。",
      costarReason: "あなたのひたむきさに共鳴し、どんな試練も一緒に越えようとしてくれる人。",
    },
    cressida: {
      name: "クレシダ",
      play: "トロイラスとクレシダ",
      word: "揺らぎ",
      intro: "戦争のさなかに恋をし、運命に引き裂かれた女性。愛と不安のあいだで、誰よりも正直に揺れた。",
      quote: "人は、手に入らないものほど、実際より高く値をつける。",
      costarReason: "揺れる心を、美しい言葉にして分かち合える人。",
    },
    jackcade: {
      name: "ジャック・ケイド",
      play: "ヘンリー六世 第2部",
      word: "大胆さ",
      intro: "人を笑わせる口のうまさで民衆を率い、ロンドンに乗りこんだ反乱の首領。",
      quote: "いちばん無秩序なときこそ、我らは秩序正しいのだ。",
      costarReason: "大胆さの裏にある本気を見抜き、知恵で支えてくれる人。",
    },
    berowne: {
      name: "ビローン",
      play: "恋の骨折り損",
      word: "照れ隠し",
      intro: "「三年間、恋はしない」と誓いながら、真っ先に恋に落ちた機知の人。冗談の裏で、誰よりも恋を信じていた。",
      quote: "恋する人の瞳こそが本であり、学問であり、学び舎だ。世界のすべてを映し、包み、育てるのだ。",
      costarReason: "あなたの照れ隠しを見抜いて、同じくらいの機知で返してくれる人。",
    },
    dromio: {
      name: "ドローミオ",
      play: "間違いの喜劇",
      word: "天真爛漫さ",
      intro: "生き別れの双子の召使い。そっくりな兄弟と取り違えられ、行く先々で大騒動に巻きこまれる。",
      quote: "おれはドローミオか？ あなたの召使いか？ おれは、おれなのか？",
      costarReason: "会えば漫才が始まる、最高の相方。ふたりそろえば客席は大爆笑。",
    },
    richard3: {
      name: "リチャード三世",
      play: "リチャード三世",
      word: "落差",
      intro: "観客に語りかけるほど魅力的で、笑顔の裏で王座への計略を巡らせた、シェイクスピア屈指の悪役。",
      quote: "さあ、我らの不満の冬は去った。ヨークの太陽が、輝かしい夏をもたらしたのだ。",
      costarReason: "あなたの企みを誰よりも早く見抜く人。手ごわいほど、あなたは本気になれる。",
    },
    bastard: {
      name: "私生児フィリップ",
      play: "ジョン王",
      word: "痛快さ",
      intro: "王家の血を引く私生児。皮肉とユーモアで権力者を笑い飛ばしながら、誰よりも勇敢に国のために戦った。",
      quote: "このイングランドは、征服者の足もとにひれ伏したことはないし、これからも決してない。",
      costarReason: "あなたの痛快さを面白がり、大きな舞台へ連れ出してくれる人。",
    },
    falstaff: {
      name: "フォルスタッフ",
      play: "ヘンリー四世 第2部",
      word: "人間くささ",
      intro: "大酒飲みでほら吹きの老騎士。王子の悪友として、笑いと人生の知恵を振りまいた。",
      quote: "わしは自分が機知に富んでいるだけでなく、まわりの者にまで機知を生ませるのだ。",
      costarReason: "あなたの冗談に本気で笑い、いつか大きな舞台に立つ姿を見せてくれる相棒。",
    },
    shylock: {
      name: "シャイロック",
      play: "ヴェニスの商人",
      word: "誇り",
      intro: "差別に耐えながら商いで生きたユダヤ人の金貸し。踏みにじられた誇りを、契約の力で取り戻そうとした。",
      quote: "針で刺されれば、我々だって血が出るではないか。",
      costarReason: "あなたが背負ってきた誇りの重さを、誰よりも分かってくれる人。",
    },
    rosalind: {
      name: "ロザリンド",
      play: "お気に召すまま",
      word: "軽やかさ",
      intro: "アーデンの森に逃れ、男装して恋の手ほどきをしながら、自分の恋を見事に実らせた機知の女性。",
      quote: "男はこれまで何人も死んで虫に食われてきたけれど、恋のために死んだ人なんていないわ。",
      costarReason: "同じように本心を隠して恋をした人。言わなくても、気持ちを分かってくれる。",
    },
    puck: {
      name: "パック",
      play: "夏の夜の夢",
      word: "遊び心",
      intro: "妖精王オーベロンに仕えるいたずら者。ほれ薬で恋人たちを大混乱させ、最後は幸せな結末へ導く。",
      quote: "ああ、人間って、なんて愚かなんだろう！",
      costarReason: "あなたのいたずらの奥にある、鋭いまなざしに気づいてくれる人。",
    },
    iago: {
      name: "イアーゴー",
      play: "オセロー",
      word: "読みの深さ",
      intro: "誰からも「正直者」と信頼されながら、言葉ひとつで人の心を操った旗手。シェイクスピア最大の謎とも言われる人物。",
      quote: "おれは、見た目どおりの人間じゃない。",
      costarReason: "どんな企みも、笑いながら見抜いてしまう人。あなたが仮面を外せる、数少ない相手。",
    },
    mrsford: {
      name: "フォード夫人",
      play: "ウィンザーの陽気な女房たち",
      word: "たくましさ",
      intro: "言い寄ってきたフォルスタッフを、友人と組んだ作戦でみごとにこらしめた、陽気で賢い奥さん。",
      quote: "誠実な男をひとり見つけるより、浮気なキジバトを二十羽見つけるほうがまだ簡単よ。",
      costarReason: "あなたと同じくらい先を読む人。組めば最強、敵に回すと最も手ごわい。",
    },
    viola: {
      name: "ヴァイオラ",
      play: "十二夜",
      word: "切なさ",
      intro: "難破して男装し、仕えた公爵に恋をしてしまった女性。本心を隠したまま、恋の使いを務め続けた。",
      quote: "ああ時よ、このもつれをほどくのはお前だ、私じゃない。私には固すぎる結び目だもの！",
      costarReason: "もつれた想いを、軽やかな知恵でほどくヒントをくれる人。",
    },
    coriolanus: {
      name: "コリオレイナス",
      play: "コリオレイナス",
      word: "潔さ",
      intro: "ローマ一の武勇を誇りながら、民衆にこびることを拒み、故郷を追われた将軍。",
      quote: "世界は、ここだけではない。",
      costarReason: "誰にもこびない誇りを、同じように持っている人。黙っていても、通じ合える。",
    },
    katherina: {
      name: "キャタリーナ",
      play: "じゃじゃ馬馴らし",
      word: "情の深さ",
      intro: "誰にも負けない毒舌で恐れられた「じゃじゃ馬」。でも、その強さの奥には、本気でぶつかれる相手を待つ心があった。",
      quote: "わたしが蜂みたいに怒りっぽいなら、針に気をつけることね。",
      costarReason: "遠慮なく本音をぶつけても、まっすぐ受け止めて燃え返してくれる人。",
    },
    beatrice: {
      name: "ベアトリス",
      play: "から騒ぎ",
      word: "機知",
      intro: "口げんかでは誰にも負けない、陽気で率直な女性。言い合いばかりしていた相手と、いつしか恋に落ちる。",
      quote: "男に愛を誓われるくらいなら、うちの犬がカラスに吠えるのを聞いていたほうがまし。",
      costarReason: "冗談の応酬がいちばん楽しい相手。軽口の奥にある本音まで分かり合える。",
    },
    titus: {
      name: "タイタス",
      play: "タイタス・アンドロニカス",
      word: "執念",
      intro: "ローマのために戦い抜いた老将軍。すべてを奪われたのち、すさまじい知略で報いを果たす。",
      quote: "わからぬのか、ルーシャス。ローマは、虎のすむ荒野にすぎないのだ。",
      costarReason: "踏みにじられる痛みを知る人。あなたの怒りの奥にある悲しみを分かってくれる。",
    },
    hotspur: {
      name: "ホットスパー",
      play: "ヘンリー四世 第1部",
      word: "まっすぐさ",
      intro: "あだ名は「熱い拍車」。名誉のためなら真っ先に馬を走らせる、血気盛んな若き武将。",
      quote: "ウサギを追い立てるより、ライオンを起こすほうが、ずっと血が騒ぐ！",
      costarReason: "あなたの熱さに負けない勢いで言い返してくる人。ぶつかるほどに、なぜか気が合う。",
    },
    macbeth: {
      name: "マクベス",
      play: "マクベス",
      word: "綱引き",
      intro: "勇猛なスコットランドの武将。魔女の予言を聞いた夜から、心の中で野心と恐れがせめぎ合いはじめる。",
      quote: "目の前に見えるのは短剣か。柄をこちらに向けて。",
      costarReason: "同じく「声」に導かれて戦場に立った人。あなたの迷いを、信じる力に変えてくれる。",
    },
    brutus: {
      name: "ブルータス",
      play: "ジュリアス・シーザー",
      word: "高潔さ",
      intro: "ローマの自由を守るため、敬愛するシーザーに刃を向けた理想家。最後まで、自分の信じる正しさに生きた。",
      quote: "人のなすことには潮時がある。満ち潮に乗れば、運は開ける。",
      costarReason: "正しさを曲げない者同士。あなたの理想を、言葉の力で支えてくれる人。",
    },
    marina: {
      name: "マリーナ",
      play: "ペリクリーズ",
      word: "清らかさ",
      intro: "嵐の海で生まれ、数奇な運命に翻弄されながらも、歌と心の清らかさで人々を救った王女。",
      quote: "わたしは生きものに、悪い言葉を言ったことも、ひどいことをしたこともありません。",
      costarReason: "あなたの清らかなやさしさを、心から必要としている人。",
    },
    hamlet: {
      name: "ハムレット",
      play: "ハムレット",
      word: "深さ",
      intro: "父の死の真相を知り、狂気を装いながら「生きるべきか、死ぬべきか」と悩み続けたデンマークの王子。",
      quote: "生きるべきか、死ぬべきか、それが問題だ。",
      costarReason: "考えすぎるあなたの頭を、いたずらでくすぐってくれる人。肩の力がふっと抜ける。",
    },
    isabella: {
      name: "イザベラ",
      play: "尺には尺を",
      word: "芯の強さ",
      intro: "修道院に入ろうとしていた女性。兄の命を救うため、権力者に知恵と言葉で立ち向かった。",
      quote: "巨人の力を持つのはすばらしい。けれど、それを巨人のように振るうのは暴君のすること。",
      costarReason: "あなたの芯の強さを、心から尊敬してくれる人。",
    },
    joan: {
      name: "ジャンヌ・ダルク",
      play: "ヘンリー六世 第1部",
      word: "信念",
      intro: "神の声を聞いたと語り、フランス軍の先頭に立って戦った羊飼いの娘。",
      quote: "栄光は、水面に広がる輪のようなもの。どこまでも大きくなり、やがて広がりきって消えていく。",
      costarReason: "あなたの信念の強さと、迷うことの怖さを、どちらも分かってくれる人。",
    },
    timon: {
      name: "タイモン",
      play: "アテネのタイモン",
      word: "純粋さ",
      intro: "惜しみなく人に与え続けたアテネの富豪。友に裏切られ、森でひとり、人間とは何かを問い続けた。",
      quote: "わたしは人間嫌い。人というものを憎んでいるのだ。",
      costarReason: "裏切られても、もう一度人を信じられることを教えてくれる人。",
    },
  },

  prospero: {
    name: "プロスペロー",
    play: "テンペスト",
    quote: "我々は、夢と同じ糸で織られている。そのささやかな一生は、眠りに包まれているのだ。",
  },

  castingText(role, types) {
    const f = types[role.front];
    const b = types[role.back];
    if (role.front === role.back) {
      return [
        `人前でも、ひとりになっても、あなたは${f.front}「${f.label}」。`,
        `裏表のないその${role.word}こそが、${role.name}。`,
      ];
    }
    return [
      `人前のあなたは、${f.front}「${f.label}」。`,
      `でもひとりになると、${b.back}「${b.label}」。`,
      `その二つの顔の${role.word}こそが、${role.name}。`,
    ];
  },

  inPublic: (label) => `人前「${label}」`,
  alone: (label) => `ひとり「${label}」`,
  playTitle: (play) => `『${play}』`,

  site: {
    title: "Bard Club｜シェイクスピアの中の、あなたの役",
    description: "12の問いから「人前のあなた」と「ひとりのあなた」を読み解き、シェイクスピア36作品の中からあなたの役を配役します。",
  },

  share: {
    hashtags: ["BardClub", "シェイクスピア"],
    title: (role) => `わたしの役は「${role.name}」でした`,
    text: (role, types) =>
      `わたしの役は「${role.name}」（『${role.play}』）でした。人前は「${types[role.front].label}」、ひとりになると「${types[role.back].label}」。あなたは誰？`,
    description: (role, types) =>
      `人前は「${types[role.front].label}」、ひとりになると「${types[role.back].label}」。12の問いで、シェイクスピア36作品の中の「あなたの役」を見つけよう。`,
  },
};
